import axios from "axios";
import { useGlobalLoader } from "vue-app/composables/useGlobalLoader";

const { hideGlobalLoader } = useGlobalLoader();

function getDateByFormat(val) {
  if (val == null) return "";
  return (
    val.getFullYear().toString() +
    "-" +
    ((val.getMonth() + 1).toString().length == 2
      ? (val.getMonth() + 1).toString()
      : "0" + (val.getMonth() + 1).toString()) +
    "-" +
    (val.getDate().toString().length == 2 ? val.getDate().toString() : "0" + val.getDate().toString())
  );
}

export default {
  setDefaultState({ commit }) {
    commit("setDefaultState");
  },
  initReport({ commit, state, dispatch }, initialState) {
    commit("setIsDev", { isDev: initialState.isDev });
    commit("setIsGlobalNewslettersReport", {
      isGlobalNewslettersReport: initialState.isGlobalNewslettersReport,
    });
    commit("setIsTransactionalEngagement", {
      isTransactionalEngagement: initialState.isTransactionalEngagement,
    });
    commit("setEngagementTypeId", {
      engagementTypeId: initialState.engagementTypeId,
    });
    commit("setTimezone", { timezone: initialState.timezone });

    if (initialState.isTransactionalEngagement) {
      axios
        .post("/json/engagements/getEngagementByType", {
          engagement_type_id: initialState.engagementTypeId,
        })
        .then((res) => res)
        .then(
          (json) =>
            new Promise((resolve, reject) => {
              resolve(json.data);
            })
        )
        .catch((err) => {
          console.log(err);
          return {};
        })
        .then((res) => {
          if ([1, 2, 3, 4, 5, 7, 9, 10, 12, 15, 16, 18, 19, 20, 21].includes(res.data.engagement.engagementTypeId)) {
            commit("setPickerStartDate", { date: getDateByFormat(new Date(new Date().getTime() - 2678400000)) });
            commit("setPickerEndDate", { date: getDateByFormat(new Date()) });
          } else {
            commit("setPickerStartDate", { date: null });
            commit("setPickerEndDate", { date: null });
          }
          commit("setEngagement", { engagement: res.data.engagement });
          commit("addToSelected", {
            engagementId: res.data.engagement.engagementId,
          });
          hideGlobalLoader();
          dispatch("loadEngagemenStatistics");
          dispatch("loadEngagementsPopularLinks");
          dispatch("getTrackerStatistics");
        });
    }
  },
  loadTrackerProductStats({ commit, state }) {
    let data;
    if (state.pickerStartDate != null && state.pickerStartDate !== "") {
      data = {
        engagement_id: state.selectedEngagements[0],
        start_date: state.pickerStartDate.split("T")[0],
        end_date: state.pickerEndDate.split("T")[0],
      };
    } else {
      data = {
        engagement_id: state.selectedEngagements[0],
      };
    }
    axios
      .post("/engagements/getTrackerProductStats", data)
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        return {};
      })
      .then((res) => {
        commit("setProductStats", { productStats: res.data });
      });
  },
  loadRecommendationProductStats({ commit, state }) {
    axios
      .post("/engagements/getRecommendationProductStats")
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        return {};
      })
      .then((res) => {
        commit("setRecommendationProductStats", {
          recommendationProductStats: res.data,
        });
      });
  },
  getEngagementStatisticTypes({ commit, state }) {
    axios
      .post("/json/engagements/getEngagementStatisticTypes")
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        return {};
      })
      .then((res) => {
        commit("setEngagementStatisticTypes", {
          engagementStatisticTypes: res.data,
        });
      });
  },
  loadEngagementsPopularLinks({ commit, state, dispatch }) {
    axios
      .post("/json/engagements/getEngagementsPopularLinks", {
        engagement_ids: state.selectedEngagements.join(","),
      })
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        return {};
      })
      .then((res) => {
        const links = res.data;
        commit("setEngagementsPopularLinks", { links: links });
      });
  },
  setVisibleInHistory({ commit, state, dispatch }, { id, isVisible }) {
    axios
      .post("/json/update-is-visible-in-history", {
        engagement_id: id,
        value: isVisible,
      })
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        return {};
      });
  },
  hideEngagement({ commit, state, dispatch }, { id, typeId }) {
    axios
      .post("/engagements/hide", {
        engagement_id: id,
        engagement_type_id: typeId,
      })
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        return {};
      })
      .then((res) => {
        commit("setHide", { id: id, value: true });
      });
  },
  unhideEngagement({ commit, state, dispatch }, { id, typeId }) {
    axios
      .post("/engagements/unhide", {
        engagement_id: id,
        engagement_type_id: typeId,
      })
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        return {};
      })
      .then((res) => {
        commit("setHide", { id: id, value: false });
      });
  },
  createNewCampaign({ commit, state, dispatch }) {
    switch (state.engagementTypeId) {
      case 8:
        window.location.href = "/app/engagements/sms-newsletter/create";
        break;
      case 17:
        window.location.href = "/app/onsite/push-newsletter/campaign/create";
        break;
    }
  },
  resendNOCA({ commit, state, dispatch }, { id, typeId }) {
    axios
      .post("/engagements/createResendCampaing", {
        engagement_id: id,
        resend_type_id: 2,
      })
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        return {};
      })
      .then((res) => {
        switch (typeId) {
          case 8:
            window.location.href = "/app/engagements/sms-newsletter/edit";
            break;
          case 17:
            window.location.href = "/app/onsite/push-newsletter/campaign/edit";
            break;
        }
      });
  },
  resendOPCA({ commit, state, dispatch }, { id, typeId }) {
    axios
      .post("/engagements/createResendCampaing", {
        engagement_id: id,
        resend_type_id: 1,
      })
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        return {};
      })
      .then((res) => {
        switch (typeId) {
          case 8:
            window.location.href = "/app/engagements/sms-newsletter/edit";
            break;
          case 17:
            window.location.href = "/app/onsite/push-newsletter/campaign/edit";
            break;
        }
      });
  },
  duplicate({ commit, state, dispatch }, { id, typeId }) {
    axios
      .post("/engagements/duplicate", {
        engagement_id: id,
        engagement_type_id: typeId,
      })
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            if (json.status === "error, can't duplicate resend") {
              reject();
              throw "Can't duplicate resend campaign";
            }
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        return {};
      })
      .then(() => {
        switch (typeId) {
          case 8:
            window.location.href = "/app/engagements/sms-newsletter/edit";
            break;
          case 17:
            window.location.href = "/app/onsite/push-newsletter/campaign/edit";
            break;
        }
      });
  },
  abort({ commit, state, dispatch }, { id, typeId }) {
    axios
      .post("/engagements/abort", {
        engagement_id: id,
        engagement_type_id: typeId,
      })
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        return {};
      })
      .then((res) => {
        commit("setStatus", { id: id, value: 3 });
      });
  },
  cancel({ commit, state, dispatch }, { id, typeId }) {
    axios
      .post("/engagements/cancel", {
        engagement_id: id,
        engagement_type_id: typeId,
      })
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        return {};
      })
      .then((res) => {
        commit("setStatus", { id: id, value: 3 });
      });
  },
  loadEngagemenStatistics({ commit, state }, { skipLoader } = {}) {
    if (!skipLoader) {
      commit("setAreStatsLoading", true);
    }
    let data = null;
    if (state.pickerStartDate != null && state.pickerStartDate !== "") {
      data = {
        engagement_ids: state.selectedEngagements.join(","),
        start_date: state.pickerStartDate.split("T")[0],
        end_date: state.pickerEndDate.split("T")[0],
      };
    } else {
      data = {
        engagement_ids: state.selectedEngagements.join(","),
      };
    }

    if (state.pickerOrderIndex != null) {
      data.order_index = state.pickerOrderIndex;
    }

    if (state.pickerEngagementMessageId != null) {
      data.engagement_message_id = state.pickerEngagementMessageId;
    }

    if (state.pickerChannelType != null && state.pickerChannelType != 0) {
      data.channel_type = state.pickerChannelType;
    }

    axios
      .post("/json/engagements/getEngagementStatistics", data)
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        commit("setAreStatsLoading", false);
        return {};
      })
      .then((res) => {
        const stats = res.data;
        commit("setAreStatsLoading", false);
        commit("setSelectedEngagementsStatistics", { stats: stats });
      });
  },
  getTrackerStatistics({ commit, state, dispatch }) {
    axios
      .post("/json/engagements/getTrackerStatistic")
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        return {};
      })
      .then((res) => {
        const stats = res.data;
        commit("setTrackerStatistics", { stats: stats });
      });
  },
  initHeaders({ commit, state, dispatch }, payload) {
    commit("isLoading", true);

    let pendingRequest = axios.post("/json/engagements/getListOfEngagements", {
      engagementTypeId: state.engagementTypeId,
    });

    pendingRequest
      .then(({ data: { data: headers } }) => {
        commit("setHeaders", { headers: headers.reverse() });

        if (payload.engagementId && headers.some((h) => h.engagementId === payload.engagementId)) {
          commit("setSelected", payload);
          dispatch("loadEngagemenStatistics", { skipLoader: false });
          dispatch("loadEngagementsPopularLinks");
        }
      })
      .catch((err) => {
        console.log(err);
        return {};
      })
      .finally(() => {
        hideGlobalLoader();
        commit("isLoading", false);
      });
  },
};
